import React from 'react'
import { Transition } from 'react-transition-group'
import PropTypes from 'prop-types'

/**
 * A wrapper component that animates it's children based on given transition Styles.
 */

function AnimateChildren (props) {
  const {
    children,
    transitionStyles,
    defaultStyles,
    in: inProp,
    unmountOnExit: unmountOnExitProp = true,
    animationContainer = true,
    duration = 150,
    ...forwardProps
  } = props

  const nodeRef = React.useRef(null)

  // will animate the children directly in the animation wrapper without a div.
  if (!animationContainer) {
    return (

      <Transition
        {...forwardProps}
        in={inProp}
        unmountOnExit={unmountOnExitProp}
        timeout={duration}
        nodeRef={nodeRef}
      >
        {state => React.Children.map(children, (child) => React.cloneElement(child, {
          ref: nodeRef,
          style: {
            ...child.props.style,
            ...defaultStyles,
            ...transitionStyles[state]
          }
        }))}
      </Transition>

    )
  }

  return (

    <Transition
      {...forwardProps}
      in={inProp}
      unmountOnExit={unmountOnExitProp}
      timeout={duration}
      nodeRef={nodeRef}
    >
      {state => (
        <div
          ref={nodeRef} style={{
            ...defaultStyles,
            ...transitionStyles[state]
          }}
        >
          {children}
        </div>
      )}
    </Transition>

  )
}

AnimateChildren.propTypes = {
  /**
   * Default style takes an object with style properties that should be default.
   * ex.
   * {
        transition: `all 150ms ease`,
        transitionProperty: 'opacity, transform',
        opacity: 0,
        };
   */
  defaultStyles: PropTypes.object,
  /**
   * Takes an object with the properties entering, entered, exiting, exited
   * these properties can have an object with the style properties that you wish to animate
   * ex.
   * {
        entering: {opacity: 0},
        entered: {opacity: 1},
        exiting: {opacity: 0},
        exited: {opacity: 0},
        };
   */
  transitionStyles: PropTypes.object,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.any,
  /**
   * unmountOnExit, unmounts the component when the exit animation finishes (default true)
   */
  unmountOnExit: PropTypes.bool,
  /**
   * How long the animation should last
   */
  duration: PropTypes.number
}

export default AnimateChildren
